import React from 'react';
import moment from 'moment';

import { PropertyWalletDetailsDTO } from '../../../services/properties';
import {
  DetailField,
  DetailFieldGrid,
  DetailFieldLabel,
  DetailFieldValue,
  DetailsSection,
  DetailsSectionTitle
} from '../styles';
import { formatPropertyAddress, formatPropertyCityState } from './propertyDetailsFormatters';

type Props = {
  details: PropertyWalletDetailsDTO;
  isLoading?: boolean;
};

const formatCurrency = (value?: number): string => {
  if (value == null || Number.isNaN(value)) return '—';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

const PropertyDetailsSummary: React.FC<Props> = ({ details, isLoading }) => {
  const fullAddress = [
    formatPropertyAddress(details.address),
    formatPropertyCityState(details.address),
    details.address?.zipcode
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <DetailsSection>
      <DetailsSectionTitle>Dados do imóvel</DetailsSectionTitle>
      {isLoading && <p style={{ margin: 0, color: '#6b7280' }}>Atualizando informações…</p>}
      <DetailFieldGrid>
        <DetailField style={{ gridColumn: '1 / -1' }}>
          <DetailFieldLabel>Endereço</DetailFieldLabel>
          <DetailFieldValue>{fullAddress || '—'}</DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Tipo</DetailFieldLabel>
          <DetailFieldValue>
            {details.type?.description || details.type?.code || '—'}
          </DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Área (m²)</DetailFieldLabel>
          <DetailFieldValue>{details.area != null ? details.area : '—'}</DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Código / matrícula</DetailFieldLabel>
          <DetailFieldValue>
            {details.identification || details.registration || '—'}
          </DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Score</DetailFieldLabel>
          <DetailFieldValue>{details.score != null ? details.score : '—'}</DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Aluguel sugerido</DetailFieldLabel>
          <DetailFieldValue>{formatCurrency(details.suggestedRentalValue)}</DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Venda sugerida</DetailFieldLabel>
          <DetailFieldValue>{formatCurrency(details.suggestedSaleValue)}</DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Condomínio</DetailFieldLabel>
          <DetailFieldValue>{formatCurrency(details.condoFee)}</DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Vagas</DetailFieldLabel>
          <DetailFieldValue>
            {details.parkingSpaces != null ? details.parkingSpaces : '—'}
          </DetailFieldValue>
        </DetailField>
        <DetailField>
          <DetailFieldLabel>Última atualização</DetailFieldLabel>
          <DetailFieldValue>
            {details.updatedAt
              ? moment(details.updatedAt).format('DD/MM/YYYY HH:mm')
              : '—'}
          </DetailFieldValue>
        </DetailField>
      </DetailFieldGrid>
    </DetailsSection>
  );
};

export default PropertyDetailsSummary;
